import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";

export class WorkplaceTypeDto extends BaseEntityDto {
  name: string;
}
